import UsersRouter from "./Users.router";

export default UsersRouter;
